"use strict";

define('rs/notifications/notifications.controller',['vertebrae', 'rs/notifications/notifications.view', 'rs/models/session'], function (Vertebrae, NotificationsView, Session) {
  var NotificationsController = Vertebrae.Controller.extend({
    properties: ['notificationManager', 'open'],
    rightOffset: 32,
    template: 'notifications.item',
    initialize: function initialize(manager) {
      this.setNotificationManager(manager);
      this._super();
      this.sync('open');
      this.sync('notifications', {
        target: manager
      });
      this.listenTo(manager, 'new', this.didReceiveNew);
    },
    refresh: function refresh() {
      return this.getNotificationManager().refresh();
    },
    next: function next() {
      return this.getNotificationManager().next();
    },
    setupView: function setupView() {
      this.setView(new NotificationsView());
    },
    getTemplateProperties: function getTemplateProperties() {
      return this.getNotificationManager().options;
    },
    getNotifications: function getNotifications() {
      return this.getNotificationManager().getNotifications();
    },
    didReceiveNew: function didReceiveNew(notifications) {},
    refreshNotificationsPropertyOnView: function refreshNotificationsPropertyOnView() {
      this.getView().refreshNotifications();
    },
    refreshOpenPropertyOnView: function refreshOpenPropertyOnView(open) {
      if (open === true) {
        this.show();
      } else if (open === false) {
        this.hide();
      }
    },
    openDidChange: function openDidChange(open) {
      if (open === true) {
        this.getNotificationManager().trigger('read');
      }
    },
    show: function show() {
      this.getView().show();
    },
    hide: function hide() {
      this.getView().hide();
    },
    toggle: function toggle() {
      this.setOpen(!this.getOpen());
    },
    requestNotificationDispatch: function requestNotificationDispatch(notification) {
      this.getNotificationManager().notificationWasSelected(notification);
      this.trigger('select', notification.item);
    },
    requestNotificationRemove: function requestNotificationRemove(notification) {
      this.trigger('remove', notification.item);
    },
    requestNotificationRemoveAll: function requestNotificationRemoveAll() {
      this.trigger('remove:all');
    }
  });
  return NotificationsController;
});

